import { render, staticRenderFns } from "./AlertCom.vue?vue&type=template&id=069dd11a&"
import script from "./AlertCom.vue?vue&type=script&lang=js&"
export * from "./AlertCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports